import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Container, Grid, Typography, Box } from '@mui/material';
import './dashboard.scss';

export default function MapDashboard() {
  const navigate = useNavigate();
  return (
    <Container sx={{ p: 4, minHeight: '100vh' }}>
      <Button
        sx={{
          mb: 2,
          color: 'primary.main',
          '&:hover': { bgcolor: 'grey.200' },
        }}
        variant="text"
        onClick={() => {
          navigate('/help-center');
        }}
      >
        <span>← Back</span>
      </Button>

      <div className="help__center__container" lang="en">
        <Box sx={{ mb: 4 }}>
          <Grid container spacing={2}>
            <Grid item>
              <Button variant="outlined" href="/help-center/dashboard">
                Overview
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" href="/help-center/building">
                Building
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" href="/help-center/devices">
                Devices
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" href="/help-center/settings">
                Settings
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" href="/help-center/map">
                Map
              </Button>
            </Grid>
          </Grid>
        </Box>
        <div className="help__center__hero">
          <h1>Map</h1>
        </div>
        <div className="content__box">
          <img src="/helpcenter/map.png" alt="Map" />
          <p>
            <strong>Map:</strong> If a building&#39;s address and GPS
            coordinates are provided, its location will be displayed on the map.
          </p>
        </div>
      </div>
    </Container>
  );
}
